import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { SearchUsersParameters, UserView } from '@api-proxies';
import { UserService } from '@http/clients/user.service';
import { GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../custom-menu-item/custom-menu-item.component';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

@Component({
    selector: 'app-salespersons-form-editor',
    templateUrl: './salespersons-form-editor.component.html',
    styleUrls: ['./salespersons-form-editor.component.scss'],
    providers: [createValueAccessorProvider(SalespersonsFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, CustomMenuItemComponent]
})
export class SalespersonsFormEditorComponent extends FormEditorBase<UserView[]> implements OnInit {
    value = input<UserView[]>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select Salespersons');

    private readonly userService = inject(UserService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadSalespersons();
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text) {
            this.items.set([]);
            return;
        }

        const users = await this.userService.search({
            filterText: text,
            isActive: true
        } as SearchUsersParameters);
        this.items.set(users);
    }

    protected override mapSelectedItemsToValue(): UserView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: UserView[]): any[] {
        return value || [];
    }

    private async loadSalespersons(): Promise<void> {
        this.items.set([]);
    }
}
